import {
  Box,
  CircularProgress,
  Container,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { isNil } from "lodash";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import RegisterBox from "../components/RegisterBox";
import { useApi } from "../hooks/useApi";
import TALogo from "../logo/TALogo.svg";
import { RegistrationDetails } from "../types/RegistrationDetails";

interface Props { }

const Register: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const [searchParams] = useSearchParams();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const [currentId] = useState<string | null>(searchParams.get("id"));

  const [nextClicked, setNextClicked] = useState<boolean>(false);

  const { data: RegistrationDetails, isLoading: isRegistrationLoading } =
    useApi<RegistrationDetails>(
      "register",
      { id: currentId! },
      undefined,
      !isNil(currentId)
    );

  const { t } = useTranslation();

  return (
    <>
      {!isRegistrationLoading ? (
        !RegistrationDetails?.results?.success ? (
          <Container
            component={Paper}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              overflow: "hidden",
              minWidth: "40%",
              width: isSmallScreen ? "100%" : "fit-content",
              padding: isSmallScreen ? "15px" : "30px",
            }}
          >
            <Stack
              padding={2}
              spacing={4}
              textAlign={"center"}
              alignItems={"center"}
            >
              <Box>
                <Box component={"img"} src={TALogo} alt="Logo" />
              </Box>
              <Typography variant="h6"> {t("registration.idNotFound")} </Typography>
            </Stack>
          </Container>
        ) : (
          RegistrationDetails?.results?.registration && (
            <RegisterBox
              nextClicked={nextClicked}
              setNextClicked={setNextClicked}
              registrationData={RegistrationDetails?.results.registration}
            />
          )
        )
      ) : (
        <Box paddingTop={4} display="flex" justifyContent="center">
          <CircularProgress size={"50px"} color="secondary" />
        </Box>
      )}
    </>
  );
};

export default Register;
